module.exports = __webpack_public_path__ + "static/img/react.8b5cab7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/discover/react.jpg
// module id = gwRe
// module chunks = 1